"use strict";
window.onload = () => {
  const target = document.getElementById("haisosm");
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(() => {
    const inputShippingDate = document.getElementById("haisoShippingdate");
    const inputShippingTime = document.getElementById("haisoShippingtime");
    const labelShippingDate = inputShippingDate.previousElementSibling;
    const labelShippingTime = inputShippingTime.previousElementSibling;
    const newElement = document.createElement("span");
    const parent = document.getElementById("haisosm");
    const child = parent.getElementsByTagName('style');
    
    parent.removeChild(child[0]);

    resizeHandler(labelShippingDate, inputShippingDate, inputShippingTime);
    labelShippingTime.textContent = "お届け時間帯";
    inputShippingDate.placeholder = "指定なし";
    inputShippingTime.firstElementChild.textContent = "指定なし";
    newElement.textContent = "※只今ご注文が大変混雑しているため、お届けに日数がかかります。";
    labelShippingTime.before(newElement);

    window.addEventListener("resize", () => {
      resizeHandler(labelShippingDate, inputShippingDate, inputShippingTime);
    });

    observer.disconnect();
  });

  if (target) {
    observer.observe(target, config);
  }

  function resizeHandler(elem, input1, input2) {
    let vw = window.innerWidth;
    if (767 < vw) {
      elem.innerHTML = "お届け希望日<small>カレンダーから選ぶ</small>";
      elem.style.display = "inline-block";
      input1.style.display = "inline-block";
      input2.style.display = "inline-block";
    } else {
      elem.textContent = "お届け希望日（カレンダーから選ぶ）";
      elem.style.display = "block";
      input1.style.display = "block";
      input2.style.display = "block";
    }
  }
};
